export default __webpack_public_path__ + "static/logo-sm-f2caf234e106b8f2557ca1fe1bd18285.png";